





































































































































































import Vue from "vue";
import { TextField, AssociationSelect, Checkbox } from "@/components";
import InvoiceData, { InvoiceDataUtils } from "@/types/invoice-data";
import { mapActions, mapGetters } from "vuex";
import { Federation } from "@/models/Federation";
import apiClient from "@/services/api.client";
import { OrderLineType } from "@/types";
import { formatDate, mergeInvoiceDataAndCalculations } from "@/utils";
import { Actions } from "@/store";
import LayoutDefault from "@/layouts/LayoutDefault.vue";

const orderLineTypeMapper = [
  {
    key: OrderLineType.Contingent,
    display: "Kontingent",
  },
  {
    key: OrderLineType.ServiceFee,
    display: "Serviceavgift",
  },
  {
    key: OrderLineType.ContingentDiscount,
    display: "Kontingent rabatt",
  },
  {
    key: OrderLineType.ServiceFeeDiscount,
    display: "Serviceavgift rabatt",
  },
];

const dateSort = (a: any, b: any): any => {
  const dateA = new Date(a).getTime();
  const dateB = new Date(b).getTime();
  return dateA - dateB;
};

export default Vue.extend({
  name: "Invoice",
  components: {
    TextField,
    AssociationSelect,
    Checkbox,
    LayoutDefault,
  },
  data() {
    return {
      tableHeaders: [
        {
          text: "Nummer",
          value: "nhoNumber",
        },
        {
          text: "Navn",
          value: "federationName",
        },
        {
          text: "Kalkulasjonstype",
          value: "orderLineType",
        },
        {
          text: "Produktnummer",
          value: "productNumber",
        },
        {
          text: "Avdeling",
          value: "department",
        },
        {
          text: "Prosjekt",
          value: "project",
        },
        {
          text: "Sist endret",
          value: "lastChanged",
          sort: dateSort,
        },
        { text: "Valg", value: "actions", sortable: false },
      ],
      invoiceData: [] as InvoiceData[],
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedItem: InvoiceDataUtils.defaultItem,
      defaultItem: InvoiceDataUtils.defaultItem,
      checkEquality: InvoiceDataUtils.checkEquality,
      loading: false,
      filter: {
        name: "",
        orderLineTypes: [] as string[],
        showOnlyMissingRows: false,
      },
    };
  },
  computed: {
    ...mapGetters(["associations", "calculations"]),
    filteredItems(): InvoiceData[] {
      return InvoiceDataUtils.filterInvoiceData(
        this.invoiceData,
        this.calculations,
        this.associations,
        this.filter
      );
    },
    formTitle(): string {
      return this.editedIndex === -1
        ? "Ny rad"
        : `Endre ${this.editedOrderLineType} for ${this.editedItem.federationName} (${this.editedItem.nhoNumber})`;
    },
    getOrderLineTypes(): Array<{ key: string; display: string }> {
      return orderLineTypeMapper.map((orderLineMap) => {
        return {
          ...orderLineMap,
          key: orderLineMap.key.toString(),
        };
      });
    },
    orderLineTypeMapper() {
      return orderLineTypeMapper;
    },
    editedOrderLineType(): string {
      return (
        orderLineTypeMapper.find(
          (mapper) => mapper.key === this.editedItem.orderLineType
        )?.display ?? ""
      );
    },
    nhoNumberProxy: {
      get(): number {
        return this.editedItem.nhoNumber;
      },
      set(val: number) {
        this.editedItem.nhoNumber = val;
        this.editedItem.federationName = this.getNameFromNumber(val);
      },
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    "editedItem.orderLineType": function (newVal) {
      switch (newVal) {
        case 0:
          this.editedItem.productNumber = "1000";
          break;
        case 1:
          this.editedItem.productNumber = "1002";
          break;
        case 2:
          this.editedItem.productNumber = "1000";
          break;
        case 3:
          this.editedItem.productNumber = "1002";
          break;
        default:
          break;
      }
    },
  },
  created() {
    if (this.calculations == undefined) {
      this.fetchCalculations().then(this.initialize);
    } else {
      this.initialize();
    }
    if (this.associations == undefined) {
      this.fetchFederations();
    }
  },
  methods: {
    ...mapActions([Actions.FETCH_CALCULATIONS, Actions.FETCH_FEDERATIONS]),
    formatDate(lastChanged: string): string {
      return formatDate(lastChanged);
    },
    getOrderLineTypeDisplay(key: number): string {
      return (
        orderLineTypeMapper.find((mapper) => mapper.key === key)?.display ??
        ""
      );
    },
    getNameFromNumber(nhoNumber: number): string {
      const item: Federation = this.associations.find(
        (org: Federation) => org.nhoNumber === nhoNumber
      );
      return item.name;
    },
    initialize(): void {
      this.loading = true;
      apiClient
        .getInvoiceData()
        .then((data: any) => {
          this.invoiceData = mergeInvoiceDataAndCalculations(
            data,
            this.calculations
          );
          this.calculations;
          this.loading = false;
        })
        .catch((err: any) => {
          console.log("Error: ", err);
          this.$toast.error("Klarte ikke å hente oppsett for fakturering");
          this.loading = false;
        });
    },
    addOrUpdateInvoiceData(item: InvoiceData): void {
      if (
        this.editedIndex === -1 &&
        InvoiceDataUtils.checkExistance(this.invoiceData, item)
      ) {
        this.$toast.error("Raden eksisterer allerede. Prøv heller å endre.");
      } else {
        this.loading = true;
        apiClient
          .addOrUpdateInvoiceData(item)
          .then(() => {
            if (this.editedIndex > -1) {
              if (this.filter.showOnlyMissingRows)
                this.$toast.success("La til manglende rad");
              else this.$toast.success("Endret eksisterende rad");
            } else {
              this.$toast.success("La til ny rad");
            }
            this.close();
            this.loading = false;
            this.initialize();
          })
          .catch((err: any) => {
            console.log("Error: ", err);
            this.$toast.error("Klarte ikke å legge til eller endre rad");
            this.close();
            this.loading = false;
          });
      }
    },
    save(): void {
      this.addOrUpdateInvoiceData(this.editedItem);
    },
    addMissingRow(item: InvoiceData): void {
      this.editedIndex = 0;
      this.editedItem = { ...item };
      this.dialog = true;
    },
    editItem(item: InvoiceData): void {
      this.editedIndex = this.invoiceData.findIndex((i) =>
        this.checkEquality(i, item)
      );
      this.editedItem = { ...item };
      this.dialog = true;
    },
    deleteItem(item: InvoiceData): void {
      this.editedIndex = this.invoiceData.findIndex((i) =>
        this.checkEquality(i, item)
      );
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm(): void {
      const { nhoNumber, orderLineType } = this.editedItem;
      this.loading = true;
      apiClient
        .deleteInvoiceData(nhoNumber, orderLineType)
        .then(() => {
          this.loading = false;
          this.initialize();
        })
        .catch((err: any) => {
          console.log("Error: ", err);
          this.$toast.error("Klarte ikke slette raden");
          this.loading = false;
        });

      this.closeDelete();
    },
    close(): void {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    closeDelete(): void {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
  },
});
